<template><div><h1 id="kapitel-9-datenschutz" tabindex="-1"><a class="header-anchor" href="#kapitel-9-datenschutz"><span>Kapitel 9. Datenschutz</span></a></h1>
<p>In diesem Kapitel sind die Instrumente zur Abdeckung der Anfordrungen bezüglich Datenschutz beschrieben.</p>
</div></template>


